import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  searchTypo: {
    width: 200,
    [theme.breakpoints.down("md")]: {
      marginTop: 20,
    },
  },
  container: {
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 20,
    flexFlow: "column",
    height: "85vh",
  },
  titleTypo: {
    fontSize: 30,
    fontWeight: 800,
  },
  fab: {
    position: "fixed",
    bottom: theme.spacing(3),
    right: theme.spacing(3),
    zIndex: 1000,
  },
  cells: { whiteSpace: "nowrap", alignItems: "center" },
  tablePaper: {
    marginTop: 20,
    marginBottom: 10,
    overflow: "auto",
    width: "calc(100vw - 20px)",
    [theme.breakpoints.up("sm")]: {
      width: "calc(100vw - 340px)",
    },
  },
  chips: {
    marginLeft: 10,
  },
  flexGrow: { flexGrow: 1 },
  filtersPaper: { padding: 10, marginTop: 15 },
  button: { marginLeft: 10 },
}));
